export const LOGGING_SERVICES = [
    { name: "Writer.Api", route: `${process.env.REACT_APP_WRITER_API_ROUTE}/logging` },
    { name: "Chat.Api", route: `${process.env.REACT_APP_CHAT_API_ROUTE}/logging` },
    { name: "Kb.Api", route: `${process.env.REACT_APP_KB_API_ROUTE}/logging` }
];
